import createComponent, {
  type ElementWithProps
} from '@carvana/merch-components/createComponent';

export const List = createComponent<
  ElementWithProps<{ isExactMatch: boolean }>
>('div', ({ isExactMatch }) => ({
  className: isExactMatch
    ? 'grid grid-cols-1'
    : 'grid gap-xl grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4',
  'data-is-exact-match': isExactMatch.toString()
}));
